<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="heading h2 t-inverse t-center">
        Sign up with email
      </h1>

      <form-base @submit.native.prevent="submit">
        <form-input type="text" label="Full name" placeholder="John Doe" v-model="name" :error="hasError('name')" :inverse="true" />
        <form-input type="text" label="Email address" placeholder="e.g. john.doe@example.com" v-model="email" :error="hasError('email')" :inverse="true" />
        <form-input type="password" label="Password" placeholder="********" v-model="password" :error="hasError('password')" :inverse="true" />
        <form-input type="password" label="Confirm Password" placeholder="********" v-model="password_confirmation" :error="hasError('password')" :inverse="true" />
        <form-checkbox :inverse="true" v-model="consent" :error="hasError('consent')">
          By creating an account you agree to our <a class="t-link" href="https://www.remax-malta.com/dataprotectionstatement.aspx" target="_blank">Terms & Conditions</a>.
        </form-checkbox>
        <button type="submit" class="button button--inverse">Sign up</button>
        <a class="button button--link button--link-inverse" @click="$router.back()">Cancel</a>
      </form-base>
    </div>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .heading {
    max-width: 350px;

    @include min-sm {
      max-width: 450px;
    }
  }

  .hr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0;

    color: rgb(var(--white));
    font-size: var(--small);

    &:before,
    &:after {
      display: block;
      width: 100%;
      content: '';
      border-bottom: 1px solid rgb(var(--white));
    }

    &:before {
      margin-right: 20px;
    }

    &:after {
      margin-left: 20px;
    }
  }

  .forgot-password {
    align-self: flex-end;
    margin-bottom: 30px;
  }
</style>

<script>
  import { backend } from '@/api';
  import form from '@/mixins/form';

  import LayoutFullscreen from '@/layouts/Fullscreen';
  import FormBase from '@/components/FormBase';
  import FormInput from '@/components/FormInput';
  import FormCheckbox from '@/components/FormCheckbox';
  import Navigation from '@/components/Navigation';

  export default {
    name: 'AccountIntro',

    mixins: [form],

    components: {
      LayoutFullscreen,
      FormBase,
      FormInput,
      FormCheckbox,
      Navigation,
    },

    data: () => ({
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      consent: false
    }),

    methods: {
      submit () {
        const { name, email, password, password_confirmation } = this;

        this.errors = [];

        if (!this.consent) {
          return this.errors.push({
            field: 'consent',
            message: 'You must check the consent checkbox.'
          })
        }

        backend.auth.email.register({ name, email, password, password_confirmation })
          .then(({ data }) => {
            this.$store.commit('updateUser', data)
            this.$router.push('/account/activate');
          })
          .catch(({ response }) => {
            this.errors = response.data.messages;
          })
      }
    }
  };
</script>